import{a as n}from"./chunk-RAAYCPUM.js";function y(...a){return n(r,a)}var r=(a,o)=>o.some(e=>e(a));export{y as a};
